
import PatientItem from "./PatientItem";
import { useRouteLoaderData } from "react-router-dom";
import { getAuthToken } from "../../../util/auth";
import { json } from "react-router-dom";
import { redirect } from "react-router-dom";
import { getApiChara } from "../../../util/getApi";
const PatientDetail = () => {
    const PatientDetails = useRouteLoaderData('Patient-Info');
        return <PatientItem PatientInfo={PatientDetails}/>;
}
     export default PatientDetail;
    export const loader = async ({params, request}) => {
      const id = params.patientID;
      const token = getAuthToken();
      if(token === null || token ==='EXPIRED'){
        return redirect('/');
      }
      const apiChar = getApiChara();
      // const apiUrl = `${apiChar}/patient/getPatientByMobile?mobile=`;
      const apiUrl = `${apiChar}/patient/getPatientById/${id}`;
      try {
        const response = await fetch(apiUrl, {
          method: request.method,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
    
        if (!response.ok) {
          throw json({ message:"could not get details"}, {status:500} );
        }
    
        const patientDetails = await response.json();
        return patientDetails;
      } catch (error) {
        throw new Error("Failed to fetch patient details.");
      }
    };